import { FormInstance } from "antd";
import { useEffect, useState } from "react";
import {
  ContentType,
  IntegrationFormData,
  IntegrationProtocol,
} from "../../../api";
import { FormWrapper } from "./FormWrapper";
import { HttpFormItems } from "./HttpFormItems";
import { TemplateFormItem } from "./TemplateFormItem";
import { TriggerEventsFormItem } from "./TriggerEventsFormItem";
import { formatTemplate } from "../../../util/formatting";

interface HttpFormProps {
  updatedProtocol: IntegrationProtocol;
  form: FormInstance<IntegrationFormData>;
  formData: IntegrationFormData;
  integrationDataLoading: boolean;
  setProtocolChanged: (newProtocol: IntegrationProtocol) => void;
}

export function HttpForm({
  updatedProtocol,
  form,
  formData,
  integrationDataLoading,
  setProtocolChanged,
}: HttpFormProps) {
  const [isFormValid, setIsFormValid] = useState(false);
  const [prevFormDataString, setPrevFormDataString] = useState<string>("");

  useEffect(() => {
    if (formData && !integrationDataLoading) {
      const currentFormDataString = JSON.stringify(formData);

      // Only update form if data has actually changed to prevent form reverting back to initial values
      if (prevFormDataString !== currentFormDataString) {
        setPrevFormDataString(currentFormDataString);

        form.setFieldsValue({
          endpointUrl: formData.endpointUrl,
          integrationName: formData.integrationName,
          integrationProtocol: updatedProtocol,
          httpMethod: formData.httpMethod,
          authType: formData.authType,
          authValue: formData.authValue,
          events: formData.events || [],
          templateContent: formatTemplate(
            formData.templateContentType,
            formData.templateContent
          ),
          templateContentType:
            formData.templateContentType ?? ContentType.APPXML,
        });
      }
    }
  }, [formData, updatedProtocol, integrationDataLoading, prevFormDataString]);

  return (
    <FormWrapper
      form={form}
      loading={integrationDataLoading}
      setFormDataReady={setIsFormValid}
      setProtocolChanged={setProtocolChanged}
    >
      <HttpFormItems formDisabled={integrationDataLoading} />
      <TriggerEventsFormItem formDisabled={integrationDataLoading} />
      <TemplateFormItem
        form={form}
        formDisabled={integrationDataLoading}
        loading={integrationDataLoading}
      />
    </FormWrapper>
  );
}
